import { colors } from '../../colors';
var pagination = {
  activeColor: colors.dirtyBlue,
  defaultColor: colors.black
};
export default pagination;